(() => {
  const streamToggles = document.querySelectorAll('[data-jsk-stream-toggle]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  streamToggles.forEach((button) => {
    const surface = button.closest('.jsk-hero, .jsk-stream-section, .jsk-collection-stream-hero');
    if (!surface) return;

    const setPaused = (paused) => {
      surface.classList.toggle('is-stream-paused', paused);
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? 'Resume motion' : 'Pause motion';
    };

    setPaused(reducedMotion);
    button.addEventListener('click', () => setPaused(button.getAttribute('aria-pressed') !== 'true'));
  });

  document.querySelectorAll('.jsk-hero__visual, .jsk-product-stream, .jsk-collection-stream-hero__products').forEach((surface) => {
    let interactionReleaseTimer;
    const pauseForInteraction = () => {
      window.clearTimeout(interactionReleaseTimer);
      surface.classList.add('is-stream-interacting');
    };
    const releaseInteraction = (delay = 0) => {
      window.clearTimeout(interactionReleaseTimer);
      interactionReleaseTimer = window.setTimeout(() => {
        if (!surface.matches(':focus-within')) surface.classList.remove('is-stream-interacting');
      }, delay);
    };

    surface.addEventListener('pointerdown', pauseForInteraction, { passive: true });
    surface.addEventListener('pointerup', () => releaseInteraction(800), { passive: true });
    surface.addEventListener('pointercancel', () => releaseInteraction(800), { passive: true });
    surface.addEventListener('focusin', pauseForInteraction);
    surface.addEventListener('focusout', () => releaseInteraction());
  });

  const sections = document.querySelectorAll('[data-jsk-compare-section]');

  sections.forEach((section) => {
    const buttons = Array.from(section.querySelectorAll('[data-jsk-compare-toggle]'));
    const panel = section.querySelector('[data-jsk-comparison]');
    const tableHead = section.querySelector('[data-jsk-comparison-head]');
    const tableBody = section.querySelector('[data-jsk-comparison-body]');
    const clearButton = section.querySelector('[data-jsk-comparison-clear]');
    const productCards = Array.from(section.querySelectorAll('[data-jsk-product]'));
    const selected = new Set();

    const render = () => {
      const cards = Array.from(selected)
        .map((id) => productCards.find((card) => card.dataset.jskProduct === id))
        .filter(Boolean);

      buttons.forEach((button) => {
        const active = selected.has(button.dataset.jskCompareToggle);
        button.setAttribute('aria-pressed', String(active));
        button.textContent = active ? 'Selected' : 'Compare';
      });

      if (cards.length < 2) {
        panel.classList.remove('is-active');
        return;
      }

      const headingCells = [];
      const specificationHeading = document.createElement('th');
      specificationHeading.scope = 'col';
      specificationHeading.textContent = 'Specification';
      headingCells.push(specificationHeading);

      cards.forEach((card) => {
        const heading = document.createElement('th');
        heading.scope = 'col';
        heading.textContent = card.dataset.title || 'Product';
        headingCells.push(heading);
      });
      tableHead.replaceChildren(...headingCells);

      const rows = [
        ['Motor', 'motor'],
        ['Battery', 'battery'],
        ['Estimated range', 'range'],
        ['Stated top speed', 'speed'],
        ['Brakes', 'brakes'],
        ['Colors', 'colors']
      ];

      const tableRows = rows.map(([label, key]) => {
        const row = document.createElement('tr');
        const rowHeading = document.createElement('th');
        rowHeading.scope = 'row';
        rowHeading.textContent = label;
        row.append(rowHeading);

        cards.forEach((card) => {
          const cell = document.createElement('td');
          cell.textContent = card.dataset[key] || 'To be confirmed';
          row.append(cell);
        });
        return row;
      });
      tableBody.replaceChildren(...tableRows);

      panel.classList.add('is-active');
      panel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.jskCompareToggle;
        if (selected.has(id)) selected.delete(id);
        else if (selected.size < 4) selected.add(id);
        render();
      });
    });

    clearButton?.addEventListener('click', () => {
      selected.clear();
      render();
    });
  });

  const requestedProduct = new URL(window.location.href).searchParams.get('product')?.trim();
  if (requestedProduct) {
    const requestedCard = Array.from(document.querySelectorAll('[data-review-code]'))
      .find((card) => card.dataset.reviewCode?.toLowerCase() === requestedProduct.toLowerCase());
    if (requestedCard) {
      requestedCard.classList.add('is-requested');
      requestedCard.setAttribute('tabindex', '-1');
      window.requestAnimationFrame(() => {
        requestedCard.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'center'
        });
        requestedCard.focus({ preventScroll: true });
      });
    }
  }

  const mobileCartBadges = Array.from(document.querySelectorAll('[data-jsk-mobile-cart-count]'));
  if (mobileCartBadges.length) {
    const updateMobileCartCount = (count) => {
      const safeCount = Number.isFinite(Number(count)) ? Math.max(0, Number(count)) : 0;
      mobileCartBadges.forEach((badge) => {
        badge.textContent = String(safeCount);
        badge.setAttribute('aria-label', `${safeCount} ${safeCount === 1 ? 'item' : 'items'} in cart`);
      });
    };

    const refreshMobileCartCount = async (cartData) => {
      if (Number.isFinite(Number(cartData?.item_count))) {
        updateMobileCartCount(cartData.item_count);
        return;
      }
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        const cart = await response.json();
        updateMobileCartCount(cart.item_count);
      } catch (error) {
        console.warn('Unable to refresh the mobile cart count.', error);
      }
    };

    const subscribeWhenReady = (attempt = 0) => {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => refreshMobileCartCount(event?.cartData));
        return;
      }
      if (attempt < 20) window.setTimeout(() => subscribeWhenReady(attempt + 1), 100);
    };
    subscribeWhenReady();
  }
})();
